import { config } from '../amplify';
import { HttpLink, ApolloLink, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { SentryLink } from 'apollo-link-sentry';
import { Auth } from '@aws-amplify/auth';
import { Hub, HubCallback } from '@aws-amplify/core';
import APIGWLink, { AuthOptions } from '@/utils/APIGWLink';
import { getWsClient, resetWsClient } from '@/utils/AuthorizedWSLink';
import { createOfflineLink } from '@bilderit/offline-link';
import { resolveCurrentIdentity } from '@/utils/currentIdentity';
import { localDateFormattingLink } from './localDateLink';
import { trimMutationStringVariablesLink } from './trimMutationStringVariablesLink';
import { backendReleaseLink } from './backendReleaseLink';
import { analyticsIntentLink, analyticsLink } from './analyticsLink';
import { errorLink } from './errorLink';

const httpUrl = config.AppSync.graphqlEndpoint as string;
const region = config.AppSync.region as string;
const auth = {
  type: config.AppSync.authenticationType,
  jwtToken: async () => {
    try {
      return (await Auth.currentSession()).getIdToken().getJwtToken();
    } catch {
      return undefined;
    }
  },
} as AuthOptions;

const authLink = new APIGWLink({ uri: httpUrl, region, auth });
const httpLink = new HttpLink({ uri: httpUrl });

const wsLink = new GraphQLWsLink(getWsClient());

const listener: HubCallback = (data) => {
  switch (data.payload.event) {
    case 'signIn':
      console.dir('sigin');
      resetWsClient();
      break;
    case 'signUp':
      break;
    case 'signOut':
      break;
    case 'signIn_failure':
      break;
    case 'configured':
      console.dir('configured');
      resetWsClient();
      break;
    default:
      break;
  }
};
Hub.listen('auth', listener);

const transportlink = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink
);

const sentryLink = new SentryLink({
  setTransaction: false,
  setFingerprint: false,
  attachBreadcrumbs: {
    includeQuery: true,
    includeCache: false,
    // Raw operation variables carry PII (dni, free text) that the analytics
    // contract (docs/product-analytics-contract.md, PII denylist) forbids
    // sending to third parties — the backend plugin redacts its copy, this
    // one has no redaction hook, so it stays off.
    includeVariables: false,
    includeError: true,
    includeContext: false,
  },
});

export const links = ApolloLink.from([
  backendReleaseLink,
  trimMutationStringVariablesLink,
  localDateFormattingLink,
  // The two analytics links are a pair around the offline link — see the
  // header of analyticsLink.ts: the intent link stamps submit-time facts
  // (before the offline package can hold or persist the mutation) and the
  // analytics link reports them once the request really goes out.
  analyticsIntentLink,
  createOfflineLink(ApolloLink, { resolveOwner: resolveCurrentIdentity }),
  analyticsLink,
  errorLink,
  sentryLink,
  authLink,
  transportlink,
]);
